import "bootstrap/dist/css/bootstrap.min.css";
import "./index.css";
import "./components/buttons/LinkButtons.css";
import "./branding/current/branding.css";

import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import promiseFinally from "promise.prototype.finally";
import { ConnectedRouter } from "connected-react-router";
import { createHashHistory } from "history";

import store from "./store";
import App from "./App";
import { bootApplication } from "./actions/configActions";
import "./misc/accessibilityChecks";
import "./misc/logHijack";
import "./misc/ieFix";
import "./misc/bootstrapFix";
import "./misc/putCursorAtEnd";

promiseFinally.shim();

var pjson = require("../package.json");
console.log(pjson.version);

store.dispatch(bootApplication());

ReactDOM.render(
  <Provider store={store}>
    <ConnectedRouter history={createHashHistory()}>
      <App />
    </ConnectedRouter>
  </Provider>,
  document.getElementById("root")
);






// WEBPACK FOOTER //
// ./src/index.js